import { RiskAiRiskType } from './types';
import { TFunction } from 'i18next';
import { RiskAiColumnConfigInterface } from '@Quarantine/store/types';
import { LogTimeUnit } from '@Log/shared';
import config from 'src/config';
import { isInUIC } from '@Utils/common';
import { OperationTabUrl } from '@Quarantine/utils/constants';

export const riskAiName = ['Correlated Intelligence', 'Risk AI'];

export const riskAiLogLink = (params: {
  securityRiskName: string;
  riskType: RiskAiRiskType;
  orgId: string;
  timeRange: LogTimeUnit;
  timeRangeStart?: string;
  timeRangeEnd?: string;
}) => {
  const {
    securityRiskName,
    riskType,
    orgId,
    timeRange,
    timeRangeStart,
    timeRangeEnd,
  } = params;
  const data = {
    ...(riskType === RiskAiRiskType.SecurityRisk
      ? { securityRiskNameFilter: securityRiskName }
      : { anomalyNameFilter: securityRiskName }),
    riskType,
    orgId,
    timeFilter: timeRange,
    ...(timeRangeStart && { timeStart: timeRangeStart }),
    ...(timeRangeEnd && { timeEnd: timeRangeEnd }),
  };
  const searchParams = new URLSearchParams(data);
  const href = `${OperationTabUrl.RiskAi}?${searchParams.toString()}`;
  return isInUIC() ? `/#${config.ui.uicPrefix}${href}` : href;
};

export const constructSecurityRiskName = (
  ruleId: string,
  ruleName: string,
  t: TFunction<'translation'>
) => {
  return t(`riskAi.detectionAnalysis.securityRiskId.${ruleId}`, ruleName ?? ''); // Fallback to name if translation with id is not found
};

export function getColumnsForExport(
  columnConfig: RiskAiColumnConfigInterface,
  t: TFunction<'translation', undefined>
) {
  const { order, i18nKeys, hideIds } = columnConfig;
  return order
    .map((id) => ({
      id,
      header: t(i18nKeys[id]),
    }))
    .filter((column) => !hideIds.includes(column.id));
}

export function getLogServiceNameFromScanSource(scanSource: string) {
  return (
    {
      'Exchange Online': 'exchange',
      'Exchange Inline': 'exchangeInline',
      gmail: 'gmail',
      'Gmail Inline': 'gmailInline',
    }[scanSource] || 'exchange'
  );
}

export const mapRiskAiDetectedBy = (
  detectedBy: string | undefined,
  t: TFunction<'translation'>
): string => {
  if (detectedBy === 'LLM') {
    return t('riskAi.llm');
  } else if (detectedBy === RiskAiRiskType.CustomizedAnomaly) {
    return t(
      `riskAi.detectionAnalysis.riskType.${RiskAiRiskType.CustomizedAnomaly.toLowerCase()}`
    );
  } else if (detectedBy === 'Mitigation') {
    return t('riskAi.mitigation');
  } else if (detectedBy === 'Correlated Intelligence') {
    return t('riskAi.correlationRule');
  } else {
    return detectedBy || '';
  }
};
